import defaults from '@/acv/constants/moneyOptions';

function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed(precision) {
  return between(0, precision, 20);
}

function toStr(value) {
  return value ? value.toString() : '';
}

function onlyNumbers(input, allowBlank) {
  const defaultValue = allowBlank ? '' : '0';
  return toStr(input).replace(/\D+/g, '') || defaultValue;
}

function numbersToCurrency(numbers, precision) {
  const exp = 10 ** precision;
  const float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
}

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function format(input, opt = defaults) {
  let inputCopy = input;
  if (opt.allowBlank && Number.isNaN(parseInt(inputCopy, 10))) {
    return '';
  }

  if (typeof inputCopy === 'number') {
    inputCopy = inputCopy.toFixed(fixed(opt.precision));
  }
  const negative = inputCopy.indexOf('-') >= 0 ? '-' : '';

  const numbers = onlyNumbers(inputCopy, opt.allowBlank);
  const currency = numbersToCurrency(numbers, opt.precision);
  const parts = toStr(currency).split('.');
  let integer = parts[0];
  const decimal = parts[1];
  integer = addThousandSeparator(integer, opt.thousands);
  return (
    opt.prefix +
    negative +
    joinIntegerAndDecimal(integer, decimal, opt.decimal) +
    opt.suffix
  );
}

function unformat(input, precision, allowBlank = false) {
  const negative = toStr(input).indexOf('-') >= 0 ? -1 : 1;
  const numbers = onlyNumbers(input, allowBlank);
  const currency = numbersToCurrency(numbers, precision);
  const value = parseFloat(currency) * negative;
  if (allowBlank && Number.isNaN(value)) {
    return '';
  }
  return value;
}

// Ignoring this method from code coverage because Vue-Test-Utils
// does not correctly change the activeElement when it gets focused - ETC
/* istanbul ignore next */
function setCursor(el, position) {
  const setSelectionRange = () => {
    el.setSelectionRange(position, position);
  };
  if (el === document.activeElement) {
    setSelectionRange();
    setTimeout(setSelectionRange, 1); // Android Fix
  }
}

// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event(name) {
  const evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}

export { format, unformat, setCursor, event, addThousandSeparator };
